import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dotdotdot from 'react-dotdotdot';
import styled from 'styled-components';
import { Avatar } from "../../../avatar/src";
import { Box } from "../../../box/src";
import { Flag } from "../../../flag/src";
import { CATEGORIES, FontAwesomeIcon } from "../../../font-awesome-icon/src";
import { Image } from "../../../image/src";
import { Link } from "../../../link/src";
export const FolderPresentation = ({ description, folderLabel = 'items', image, isLast, name, path, user, }) => (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [_jsx(ImageWrapper, { "$isLast": isLast, children: _jsxs(Link, { styledOnlyOnHover: true, tabIndex: -1, to: path, width: "100%", children: [image ? (_jsx(Image, { alt: "", height: "100%", src: image, style: { objectFit: 'cover' }, width: "100%" })) : (_jsx(IconWrapper, { children: _jsx(FontAwesomeIcon, { color: "primary", height: "40px", iconName: "folders", iconType: CATEGORIES.DUOTONE }) })), _jsx(FlagWrapper, { children: _jsx(Flag, { text: folderLabel }) })] }) }), _jsxs(Box, { flexDirection: "column", justifyContent: "center", maxWidth: "100%", mb: isLast ? 0 : { _: 5, m: 6 }, children: [_jsx(Box, { mb: 1, children: _jsx(Link, { font: "h4-semibold", styledOnlyOnHover: true, to: path, width: "100%", children: _jsx(Dotdotdot, { clamp: 2, useNativeClamp: true, children: name }) }) }), _jsx(Box, { children: _jsx(TextWrapper, { width: "100%", children: _jsx(Dotdotdot, { clamp: 2, useNativeClamp: true, children: description }) }) }), user && (_jsxs(Box, { alignItems: "center", children: [_jsx(Avatar, { alt: "", height: "32px", href: user.path, mr: 3, mt: 2, src: user.photo_thumb_url, tabIndex: -1, width: "32px" }), _jsx(Box, { alignItems: "center", justifyContent: "center", children: _jsx(Link, { font: "body-semibold-asphalt", styledOnlyOnHover: true, to: user.path, width: "100%", children: user.name }) })] }))] })] }));
const ImageWrapper = styled(Box).attrs(({ $isLast }) => ({
    height: '118px',
    maxWidth: { _: '221px', m: '210px' },
    mb: { _: 3, m: $isLast ? 0 : 6 },
    minHeight: '118px',
    minWidth: { _: '221px', m: '210px' },
    mr: 5,
})) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
  position: relative;
`;
const TextWrapper = styled(Box) `
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
`;
const FlagWrapper = styled(Box).attrs({
    m: 2,
}) `
  position: absolute;
  top: 0;
`;
const IconWrapper = styled(Box) `
  height: 118px;
  align-items: center;
  justify-content: center;
  border: solid 1px ${({ theme }) => theme.colors.horizon};
  border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
`;
//# sourceMappingURL=FolderPresentation.js.map